import scrollTo from "./scrollTo"
import getApiBaseUrl from "./getApiBaseUrl"
import ROUTES from "./routes"
import isEqual from "./isEqual"
import { displayDate } from "./displayDate"
import { getAllIndustries } from "./industries"
import { getAllCurrencies } from "./currencies"
import { getAllTimezones } from "./timezones"
import { getAllTimes } from "./times"
import { getAllCountries, getStatesByCountryId } from "./countries"
import {
  cacheData,
  getCachedData,
  removeCachedData,
  sessionData,
  getSessionData,
  removeSessionData
} from "./cacheData"
import {
  getCitiesByStateId,
  getBarangaysByCityId
} from "./philippinesLocations"

export {
  scrollTo,
  getApiBaseUrl,
  ROUTES,
  cacheData,
  getCachedData,
  removeCachedData,
  sessionData,
  getSessionData,
  removeSessionData,
  isEqual,
  getAllCountries,
  getStatesByCountryId,
  getCitiesByStateId,
  getBarangaysByCityId,
  getAllIndustries,
  getAllCurrencies,
  getAllTimezones,
  getAllTimes,
  displayDate
}
